var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WhiteBlackButton',{attrs:{"css_class":_vm.css_class,"title":_vm.title},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('user-icon')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }